var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.091,
    height: 19.091,
    viewBox: "0 0 19.091 19.091",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_document-copy",
    "data-name": "vuesax/bulk/document-copy",
    transform: "translate(-684 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "document-copy",
    transform: "translate(684 188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.739,4.892H9.012A2.568,2.568,0,0,1,6.443,2.323V.6a.6.6,0,0,0-.6-.6H3.325A3.15,3.15,0,0,0,0,3.325V8.607a3.15,3.15,0,0,0,3.325,3.325H8.01a3.15,3.15,0,0,0,3.325-3.325V5.489A.6.6,0,0,0,10.739,4.892Z",
    transform: "translate(1.591 5.568)",
    fill: "#292d32",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8,0H3.317A3.139,3.139,0,0,0,0,3.19c.048,0,.087-.008.135-.008H4.82A3.15,3.15,0,0,1,8.145,6.507V11.8c0,.048-.008.087-.008.127a3.128,3.128,0,0,0,3.19-3.309V3.325A3.15,3.15,0,0,0,8,0Z",
    transform: "translate(6.173 1.591)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M.668.118A.389.389,0,0,0,0,.38V2.464A1.623,1.623,0,0,0,1.647,4.055c.565.008,1.352.008,2.028.008a.374.374,0,0,0,.278-.636C3.086,2.56,1.543,1.008.668.118Z",
    transform: "translate(8.861 5.57)",
    fill: "#292d32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H19.091V19.091H0Z",
    fill: "none",
    opacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCopy);
export default __webpack_public_path__ + "static/media/document-copy.63cbace320ab8c835dd89fe07cdfce40.svg";
export { ForwardRef as ReactComponent };